import { generatePath } from 'react-router-dom';
import { Overwrite } from 'utility-types';
import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { AlertDto } from '@/Domain/api/Conversation/dto/Alert.dto';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export type AlertCreateInput = Pick<AlertDto, 'name' | 'description'> &
  Partial<Pick<AlertDto, 'is_active'>>;

export class ConversationAnalysisAlertsApi {
  static list = (): Promise<AlertDto[]> =>
    httpClient.get(Endpoint.conversationAnalysisAlerts.list).then(ApiMapper.toResponseData);

  static get = (alertId: number): Promise<AlertDto> =>
    httpClient
      .get(generatePath(Endpoint.conversationAnalysisAlerts.get, { alertId: String(alertId) }))
      .then(ApiMapper.toResponseData);

  static create = (alert: AlertCreateInput): Promise<AlertDto> =>
    httpClient
      .post(Endpoint.conversationAnalysisAlerts.create, alert)
      .then(ApiMapper.toResponseData);

  static update = ({ id, ...alert }: Overwrite<AlertDto, { id: number }>): Promise<AlertDto> =>
    httpClient
      .patch(
        generatePath(Endpoint.conversationAnalysisAlerts.update, { alertId: String(id) }),
        alert,
      )
      .then(ApiMapper.toResponseData);

  static remove = (alertId: number): Promise<void> =>
    httpClient
      .delete(
        generatePath(Endpoint.conversationAnalysisAlerts.delete, { alertId: String(alertId) }),
      )
      .then(ApiMapper.toResponseData);
}
